import * as Sentry from '@sentry/react';

let initialized = false;

export function initSentry(): void {
  if (initialized) return;
  const dsn = (process.env.REACT_APP_SENTRY_DSN ?? '').trim();
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV ?? 'development',
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0,   // explicitly off — privacy + cost
    replaysOnErrorSampleRate: 0,
  });
  initialized = true;
}

export function captureException(err: unknown, ctx?: Record<string, unknown>): void {
  if (!(process.env.REACT_APP_SENTRY_DSN ?? '').trim()) return;
  Sentry.captureException(err, ctx ? { extra: ctx } : undefined);
}
